import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import ToggleButtonGroup, {
  ToggleButton,
} from '@/components/ui/custom/dataInput/ToggleGroup';
import User, { UserTypeEnum } from '@/models/User';
import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import ScheduledLesson from '@/models/ScheduledLesson';
import HomeworkActivity from '@/models/HomeworkActivity';
import { HomeworkEdit } from '@/components/teacher/HomeworkEdit';
import ScheduledLessonResourceContainer from '@/components/resource/scheduled-lesson/ScheduledLessonResourceContainer';

type Props = {
  user: User;
  scheduledLesson: ScheduledLesson;
  slugCourseName: string;
  homework?: HomeworkActivity;
};

type ReportActionTab = 'homework' | 'resources';

export type ReportActionTabs = Record<ReportActionTab, JSX.Element>;

export default function LessonReportActions(props: Props) {
  const [t] = useTranslation('translation', {
    keyPrefix: 'common',
  });

  const { scheduledLesson, homework, user, slugCourseName } = props;

  const [tab, setTab] = useState<ReportActionTab>('homework');

  const tabs: ReportActionTabs = {
    homework: (
      <HomeworkEdit
        homeworkActivity={homework}
        klassId={scheduledLesson.klass}
        scheduledLesson={scheduledLesson}
      />
    ),
    resources: (
      <ScheduledLessonResourceContainer
        user={user}
        slugCourseName={slugCourseName}
        scheduledLesson={scheduledLesson}
      />
    ),
  };

  const buttons: ToggleButton<ReportActionTab>[] = [
    {
      testId: 'addHomeworkButton',
      text: t('homework'),
      value: 'homework',
    },
    {
      testId: 'addResourcesButton',
      text: t('resources'),
      value: 'resources',
    },
  ];

  return (
    <section className="flex flex-col gap-2.5">
      <ComponentGuard
        roles={[
          UserTypeEnum.SUPER_ADMIN,
          UserTypeEnum.TEACHER,
          UserTypeEnum.UNIT_ADMIN,
        ]}
      >
        <nav className="flex w-full justify-start">
          <ul className="flex gap-1">
            <ToggleButtonGroup
              buttons={buttons}
              value={tab}
              onChange={setTab}
              exclusive
            />
          </ul>
        </nav>
      </ComponentGuard>
      {tabs[tab]}
    </section>
  );
}
